import { AppContextType } from "src/AppContextProvider/type";
import { ROUTES } from "src/constants/routes";

/**
 * The billing page for the current org.
 *
 * @remarks
 * v2 orgs go to `/billing/v2`. v1 orgs keep today's rule: the space-based billing page when the SBB flag is on, else
 * `/billing/latest`. While the billing version is still loading, the v1 link is used; `BillingVersionGuard` redirects
 * if it turns out to be v2.
 */
export const billingRoute = (
  context: Pick<AppContextType, "billingVersion" | "hasSbbFlag">,
): string => {
  if (context.billingVersion === "v2") {
    return ROUTES.ACCOUNT_V2;
  }
  return context.hasSbbFlag() ? ROUTES.ACCOUNT : ROUTES.ACCOUNT_LATEST;
};
